import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import EntityCardGrid from '../../common/components/EntityCardGrid';
import EntityCard from '../../common/components/EntityCard';
import usePermissoes from '../../common/hooks/usePermissoes';
import Permissoes from '../../common/permissoes';

function Veiculo() {
    const { hasPermission } = usePermissoes();
    const [data, setData] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get('/veiculo');
                setData(response.data);
            } catch (error) {
                console.error('Erro ao buscar veículos:', error);
            }
        }

        fetchData();
    }, []);

    return (
        <PageContainer>
            <PageHeader
                title="Veículos"
                actionLabel={hasPermission(Permissoes.VEICULO_CADASTRO) ? "Adicionar Veículo" : undefined}
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/veiculo/cadastro"
            />

            <EntityCardGrid
                items={data}
                keyExtractor={(veiculo) => veiculo.id}
                emptyMessage="Nenhum veículo encontrado."
                renderItem={(veiculo) => (
                    <EntityCard
                        to={`/veiculo/${veiculo.id}`}
                        image={veiculo.foto ? `data:image/jpeg;base64,${veiculo.foto}` : null}
                        icon={<DirectionsCarOutlinedIcon fontSize="inherit" />}
                        title={veiculo.tipo}
                        subtitle={`${veiculo.marca || ''}${veiculo.marca && veiculo.placa ? ' · ' : ''}${veiculo.placa || ''}`}
                    />
                )}
            />
        </PageContainer>
    );
}

export default Veiculo;
